<template>
  <section class="people" id="people">
    <div class="container">
      <div class="plaque-title"><h2>Research Team</h2></div>
      <div class="team-grid">
        <div v-for="(person, index) in team" :key="index" class="team-member">
          <img :src="person.image" :alt="person.name" class="member-image">
          <h3>
            <a v-if="person.website" :href="person.website" target="_blank" rel="noopener noreferrer" class="person-name-link">
              {{ person.name }}
            </a>
            <template v-else>
              {{ person.name }}
            </template>
          </h3>
          <p>{{ person.role }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PeopleSection',
  data() {
    return {
      team: [
        {
          name: 'Paul Ehling',
          image: '/images/APHIOG_Ehling_150.jpg',
          role: 'Professor',
          website: 'https://www.bi.no/en/about-bi/employees/department-of-finance/paul-ehling'
        },
        {
          name: 'Junjie Guo',
          image: '/images/Junjie_Guo_150.jpg',
          role: 'Assistant Professor',
          website: 'https://ensf.cufe.edu.cn/info/1113/1767.htm'
        },
        {
          name: 'Christian Heyerdahl-Larsen',
          image: '/images/APHIOG_Heyerdahl-Larsen_150_UP.jpg',
          role: 'Professor',
          website: 'https://christian.heyerdahllarsen.com/'
        },
        {
          name: 'Petra Sinagl',
          image: '/images/Sinagl_Petra_150.jpg',
          role: 'Assistant Professor',
          website: 'https://petrasinagl.com/'
        },
        {
          name: 'Wei Wang',
          image: '/images/Wang_Wei_150.jpg',
          role: 'Assistant Professor',
          website: 'https://weiwangfinance.github.io/homepage/'
        },
        {
          name: 'Costas Xiouros',
          image: '/images/Xiouros_Costas_150.jpg',
          role: 'Associate Professor',
          website: 'https://home.bi.no/costas.xiouros/'
        },
        {
          name: 'Zeshu Xu',
          image: '/images/ZeshuXuImage.jpg',
          role: 'PhD Candidate',
          website: 'https://zeshuxu.weebly.com/'
        },
        // {
        //   name: 'Lochstoer',
        //   image: '/images/APHIOG_Lochstoer_150.jpg',
        //   role: 'Researcher'
        // },
      ]
    }
  }
}
</script>

<style scoped>
.people {
  padding: 4rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.plaque-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
}

.plaque-title h2 {
  background: rgba(255,255,255,0.85);
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border-radius: 16px;
  padding: 1rem 2.5rem;
  font-size: 2.5rem;
  color: #1a1a1a;
  backdrop-filter: blur(6px);
  margin: 0;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  justify-items: center;
}

.team-member {
  width: 240px;
  height: 220px;
  text-align: center;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.team-member:hover {
  transform: translateY(-5px);
}

.member-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-bottom: 1rem;
  object-fit: cover;
  object-position: center 0%;
}

h3 {
  font-size: 0.9rem;
  color: #1a1a1a;
  margin-bottom: 0.3rem;
}

.person-name-link {
  color: inherit; /* Inherits color from h3 */
  text-decoration: none; /* Removes underline */
}

.person-name-link:hover {
  text-decoration: underline; /* Optional: add underline on hover */
}

p {
  margin: 0;
  color: #666;
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .team-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
</style>
